import React from "react";
import { Star } from "lucide-react";

// Part 1: The colored status pill
export const StatusBadge = ({ status }) => {
  const styles = {
    todo: "bg-stone-100 text-stone-500 border-stone-200",
    doing: "bg-stone-100 text-[#1F6F54] border-[#1F6F54]",
    blocked: "bg-rose-50 text-rose-800 border-rose-200",
    done: "bg-[#EAF4EF] text-[#1F6F54] border-[#1F6F54] opacity-80",
  };

  return (
    <span
      className={`px-2 py-0.5 rounded text-[10px] font-semibold border ${
        styles[status] || styles.todo
      } uppercase tracking-wider`}
    >
      {status}
    </span>
  );
};

// Part 2: The star indicator
export const PriorityIndicator = ({ priority }) => {
  if (priority === "low") return null;
  return (
    <div className="flex items-center gap-1">
      {priority === "high" && (
        <Star className="w-3 h-3 text-amber-500 fill-amber-500" />
      )}
    </div>
  );
};
